import type { ArmedTool } from './armedTool';
import type { AssetRailTab } from './assetRailTabs';

/** The kind of asset the canvas treats as in hand: an equipment, with its instruments, or a line. */
export type ActiveAssetKind = 'equipment' | 'line';

/**
 * DECISION(2026-10-27, abhishek): Equipment armed is equipment, and Line or Duct armed is line;
 * with Instrument armed or nothing armed the rail tab decides (Lines is line, else equipment).
 * An instrument hangs off an equipment or a line, so the Instrument tool names no kind: one
 * drawn on the Lines tab attaches to the active line. No new state.
 */
export function activeAssetKind({ armedTool, railTab }: { armedTool: ArmedTool | null; railTab: AssetRailTab }): ActiveAssetKind {
  if (armedTool === 'equipment') return 'equipment';
  if (armedTool === 'line' || armedTool === 'duct') return 'line';
  return railTab === 'lines' ? 'line' : 'equipment';
}
